<template>
  <div>
    <TopBar />
    <div class="container-xl">
      <RouterView />
    </div>
    <FooterBase />
  </div>
</template>

<script>
import TopBar from "./../components/TopBar";
import FooterBase from "./../components/Footer";

export default {
  name: "Site",
  components: {
    TopBar,
    FooterBase
  },
  mounted() {
    this.addAuthClassName();
  },
  methods: {
    addAuthClassName() {
      const body = document.body;
      body.className = "";
      body.classList.add("Auth");
    }
  }
};
</script>

<style>
.Auth {
  background-color: white;
}
</style>
